import { I18N } from "oc-I18N";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";

export function ZaunCircleMenuItemFillWithElements() {
  const agt = APP.arrangement;
  const contract = () => {
    const elemente = agt.selectedObjects;
    return !elemente.some((e) => !e.isEmpty);
  };
  if (!contract()) {
    return null;
  }
  const label = I18N("Strecke auffüllen");
  return (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={(event) => {
        event.stopPropagation();
        if (!contract()) {
          return null;
        }

        APP.update3d();
        APP.logUserAction({ action: "fillWithElements" });

        const added = agt.selectedObjects.flatMap((empty) => {
          const element = agt.createDefaultElementWithout3D({
            füllungAuswahlwert: agt.füllungAuswahlwert,
          });
          return empty.fillWithElements(element, {
            allowMassElement: true,
            minimalOneElement: true,
          });
        });

        if (_.sumBy(added, (a) => a.size?.x) > 0) {
          APP.arrangement.setSelectedObjects(added);
          agt.update3d();
          APP.dirty();
        } else {
          APP.arrangement.setSelectedObjects(null);
        }
      }}
    >
      {label}
    </ZaunCircleMenuItem>
  );
}
